import { AB_MULTI_BOARD } from "@/constants/ABMng";
import { useLocalStorageState } from "ahooks";
import useABTest from "./useABtest";

const key = "ab_multi_board_flag";

/**
 * AB实验控制多人画板功能是否开启
 * @returns {
 *   enable: boolean,
 *   setEnable: (enable: boolean) => void,
 * } enable: 是否开启多人画板功能, setEnable: 设置是否开启多人画板功能(用于接受多人画板邀请时设置)
 */
export function useEnableMultiBoard() {
  const multiBoard = useABTest(AB_MULTI_BOARD);

  const [localFlag, setLocalFlag] = useLocalStorageState(key);

  return {
    enable: multiBoard.new || !!localFlag,
    setEnable: setLocalFlag,
  };
}
